import { useTranslation } from 'react-i18next';
import { useCopyToClipboard } from 'usehooks-ts';

import { InfoRow, type InfoRowProps } from '@app/shared/ui/molecules/Common';
import { CopyLabel } from '@app/shared/ui/atoms/Admin/WithdrawalDetails';
import { telegramVibrate } from '@app/shared/utils/common';
import notification from '@app/shared/utils/notification';

interface CopyableInfoRowProps extends Omit<InfoRowProps, 'label' | 'value'> {
  label: string;
  valueToDisplay: string | number;
  valueToCopy: string | number;
}

export function CopyableInfoRow({
  label,
  valueToDisplay,
  valueToCopy,
  ...rest
}: CopyableInfoRowProps) {
  const { t } = useTranslation();
  const [, copyToClipboard] = useCopyToClipboard();

  const handleCopyToClipboard = () => {
    telegramVibrate();
    copyToClipboard(`${valueToCopy}`).then(() => notification.success(t('common.copied')));
  };

  return (
    <InfoRow
      label={label}
      value={<CopyLabel label={`${valueToDisplay}`} onCopy={handleCopyToClipboard} />}
      {...rest}
    />
  );
}
